import React from "react";
import Footer from "../utils/footer";
import PageSeo from "../components/common/PageSeo";
import { BUSINESS_INFO } from "../constants/businessInfo";

const PrivacyPolicy = () => {
  return (
    <main className="bg-slate-50 pt-28 text-slate-800">
      <PageSeo
        title="Privacy Policy"
        description="Read the Privacy Policy of Thakkhar Realtors covering data collection, cookies, analytics, contact forms, and user rights."
      />

      <section className="mx-auto max-w-4xl px-6 pb-16">
        <header className="rounded-2xl bg-white p-8 shadow-sm">
          <h1 className="text-3xl font-bold text-slate-900">Privacy Policy</h1>
          <p className="mt-3 text-sm text-slate-600">
            Last updated: 18 June 2026
          </p>
          <p className="mt-4 text-slate-700">
            Thakkhar Realtors respects your privacy. This policy explains how we
            collect, use, protect, and process your information when you use our website.
          </p>
        </header>

        <div className="mt-6 space-y-4">
          <PolicyCard title="1. Information We Collect">
            We may collect your name, phone number, email address, and property preferences
            when you submit forms, request callbacks, or contact us.
          </PolicyCard>

          <PolicyCard title="2. Cookies and Similar Technologies">
            Our website may use cookies to improve user experience, remember preferences,
            and understand website traffic patterns.
          </PolicyCard>

          <PolicyCard title="3. Analytics">
            We may use analytics tools to measure traffic behavior, popular pages,
            and interaction patterns to improve our services.
          </PolicyCard>

          <PolicyCard title="4. Contact Forms and Inquiries">
            Information submitted through contact forms is used solely to respond
            to your inquiry, share relevant property details, and provide support.
          </PolicyCard>

          <PolicyCard title="5. Data Usage">
            We use your information for communication, service delivery, inquiry follow-up,
            scheduling visits, and improving overall service quality.
          </PolicyCard>

          <PolicyCard title="6. Data Protection">
            We implement reasonable technical and administrative safeguards to protect
            your data against unauthorized access, misuse, and accidental loss.
          </PolicyCard>

          <PolicyCard title="7. Third-Party Services">
            Our website may include third-party integrations such as map providers,
            messaging platforms, and analytics tools. Their processing is governed by
            their own privacy policies.
          </PolicyCard>

          <PolicyCard title="8. User Rights">
            You may request access, correction, or deletion of your personal data,
            subject to applicable legal and business obligations.
          </PolicyCard>

          <PolicyCard title="9. Contact Details">
            <p>
              For privacy-related requests, contact us at
              <a
                href={`mailto:${BUSINESS_INFO.businessEmail}`}
                className="ml-1 text-blue-700 hover:underline"
              >
                {BUSINESS_INFO.businessEmail}
              </a>
              or call
              <a
                href={`tel:${BUSINESS_INFO.phone.replace(/\s+/g, "")}`}
                className="ml-1 text-blue-700 hover:underline"
              >
                {BUSINESS_INFO.phone}
              </a>
              .
            </p>
          </PolicyCard>
        </div>
      </section>

      <Footer />
    </main>
  );
};

const PolicyCard = ({ title, children }) => (
  <article className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
    <h2 className="text-lg font-semibold text-slate-900">{title}</h2>
    <div className="mt-2 text-sm leading-6 text-slate-700">{children}</div>
  </article>
);

export default PrivacyPolicy;
